import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/loginSlice";

const rootReducer = combineReducers({
  auth: authReducer,
});

export default rootReducer;
